import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatButton = createCustomElementWrapper('kat-button', 'KatButton', {
    'fullWidth': 'full-width',
    'katAriaLabel': 'kat-aria-label',
}, {}, [
    'icon',
]);
